module.exports = __webpack_public_path__ + "img/Roadshow SMK 41 Jakarta.0ef1e9d2.jpeg";